import styled from '@emotion/styled'

export const ReceiptsSelectAllActionWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`
